'use client';

import { ReactNode } from 'react';
import { LDProvider, ProviderConfig } from 'launchdarkly-react-client-sdk';

interface ChildWithLaunchDarklyContext extends ProviderConfig {
  children: ReactNode;
}

export default function LDProviderWrapper(props: Readonly<ChildWithLaunchDarklyContext>) {
  const { children, ...providerConfig } = props;
  return <LDProvider {...providerConfig}>{children}</LDProvider>;
}
